import { Controller } from "@hotwired/stimulus"

// Olho para mostrar/ocultar a senha + barra segmentada de força.
// Critérios: tamanho, minúscula, maiúscula, número e caractere especial.
export default class extends Controller {
  static targets = ["input", "icon", "meter", "segment", "label"]

  connect() {
    if (this.hasMeterTarget) this.evaluate()
  }

  toggle() {
    if (!this.hasInputTarget) return
    const visivel = this.inputTarget.type === "text"
    this.inputTarget.type = visivel ? "password" : "text"
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-eye", visivel)
      this.iconTarget.classList.toggle("fa-eye-slash", !visivel)
    }
  }

  evaluate() {
    if (!this.hasMeterTarget) return
    const valor = this.inputTarget.value
    const { preenchidos, texto, cor, corTexto } = this.forca(valor)

    this.meterTarget.classList.toggle("d-none", valor.length === 0)
    this.segmentTargets.forEach((seg, i) => {
      seg.className = `flex-fill rounded-pill ${i < preenchidos ? cor : "bg-secondary bg-opacity-25"}`
      seg.style.height = "5px"
    })
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = texto
      this.labelTarget.className = `small fw-medium mt-1 d-block ${corTexto}`
    }
  }

  // 5 critérios -> barra de 5 segmentos
  forca(senha) {
    if (!senha) return { preenchidos: 0, texto: "", cor: "", corTexto: "" }

    let pontos = 0
    if (senha.length >= 8) pontos++
    if (/[a-z]/.test(senha)) pontos++
    if (/[A-Z]/.test(senha)) pontos++
    if (/\d/.test(senha)) pontos++
    if (/[^A-Za-z0-9]/.test(senha)) pontos++

    if (pontos <= 2) {
      return { preenchidos: Math.max(pontos, 1), texto: "Fraca", cor: "bg-danger", corTexto: "text-danger" }
    }
    if (pontos <= 4) {
      return { preenchidos: pontos, texto: "Média", cor: "bg-warning", corTexto: "text-warning" }
    }
    return { preenchidos: 5, texto: "Forte", cor: "bg-success", corTexto: "text-success" }
  }
}
